// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".relative[data-v-eb7fc1fe]{position:relative}.logo amp-img[data-v-eb7fc1fe],.logo img[data-v-eb7fc1fe]{height:50px;width:151px}.logo.centered[data-v-eb7fc1fe],.logo.centered amp-img[data-v-eb7fc1fe],.logo.centered img[data-v-eb7fc1fe]{margin:0 auto}.logo.footer-logo img[data-v-eb7fc1fe]{right:0;left:0;top:38px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
